import { IScormPackage } from "../../App/types/common";

export const scormPackagesByCourse: (
  scormPackages: IScormPackage[]
) => {
  [k: string]: IScormPackage[];
} = scormPackages => {
  return scormPackages.reduce((acc: { [k: string]: IScormPackage[] }, sp: IScormPackage) => {
    acc[sp.courseId] = acc[sp.courseId] === undefined ? [sp] : [...acc[sp.courseId], sp];
    return acc;
  }, {});
};
